const progressTypes = {
  OPPORTUNITY_FOR_GROWTH: 'growth',
  PROGRESSING: 'progressing',
  STRENGTH: 'strength',
};

const determineFunc = (scorePercent, lowWindow, highWindow) => {
  if (scorePercent <= lowWindow) {
    return progressTypes.OPPORTUNITY_FOR_GROWTH;
  } else if (scorePercent <= highWindow) {
    return progressTypes.PROGRESSING;
  }

  return progressTypes.STRENGTH;
};

const algebraGeometryWindows = { low: 34, high: 55 };
const englishWindows = { low: 54, high: 75 };
const biologyChemistryWindows = { low: 49, high: 70 };
const historyWindows = { low: 39, high: 60 };

/**
 * Determines the result progress of an entire class, based on
 * guidelines per subject. Returns a string corresponding to one of
 * `progressTypes.OPPORTUNITY_FOR_GROWTH`, `progressTypes.PROGRESSING`
 * or `progressTypes.STRENGTH`.
 * @param scorePercentage - The cumulative class score as a percentage of total correct points (0 to 100)
 * @param subjectId - The subject id of the current subject, as a string
 * @returns {string} - The progress classification
 */
const determineResultProgress = (scorePercentage, subjectId) => {
  let windows;
  switch (subjectId) {
    case '104': // Algebra
    case '114': // Geometry
    case '115': // Algebra 2
      windows = algebraGeometryWindows;
      break;
    case '106': // English 1
    case '112': // English 2
      windows = englishWindows;
      break;
    case '105': // Biology
    case '113': // Chemistry
      windows = biologyChemistryWindows;
      break;
    case '107': // World History and Geography
      windows = historyWindows;
      break;
    default:
      windows = algebraGeometryWindows;
      break;
  }

  return determineFunc(scorePercentage, windows.low, windows.high);
};

export {
  progressTypes,
  determineResultProgress,
  algebraGeometryWindows,
  historyWindows,
  englishWindows,
  biologyChemistryWindows,
};
